import React from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import cookie from 'react-cookies'
import {
    Button,
    TextField,
    Select, MenuItem,    
} from '@material-ui/core/';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
// import TextField from '@material-ui/core/TextField';
import cookie from 'react-cookies'
import { getAuditedListByUser, fetchQATranscriptionAudio, setPageName, superQAAudioDecision, fetchRejectReajonList,fetchEnglishKeywords,saveKeywordSuggestions,fetchKeywordsAudit,saveKeywordAudit } from '../../../service/action/audio-track-action';
import { Loader, DatePicker } from '../../../Components'
import FormControl from '@material-ui/core/FormControl';
import CreatorDashboardReducer from '../../../service/reducer/creator-dashboard-reducer';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
const useStyles1 = makeStyles((theme) => ({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
  }));
  
  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onChangePage(event, 0);
    };
  
    const handleBackButtonClick = (event) => {
      onChangePage(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onChangePage(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
  
    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
  
  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };
  
   
  const useStyles2 = makeStyles({
    table: {
      minWidth: 300,
    },
  });
  function KeywordAuditTable(props)
  {
    const {rows} = props;
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    let keywordAudit = [...rows].map((col)=>{
        col.keywordAudit = "keywordAudit" in col ? col.keywordAudit : false;
        return col;
    });
    
    const [possibleWords,setPossibleWords] = React.useState(keywordAudit);
    const [change,setChange] = React.useState(true);
  
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const handlePossibleWordChange = (e,i)=>{
        let changePossibleWord = [...possibleWords];
        changePossibleWord[i].Possibleword = e.target.value;
        // setChange(!change);
        setPossibleWords(changePossibleWord);
    };
    const handleEdit = (i,status)=>{
        let tempResults = [...possibleWords];
        tempResults[i].keywordAudit = status;
        setPossibleWords(tempResults)
    }
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    
    return (
        
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="custom pagination table">
        <TableHead>
            <TableRow>
                <TableCell>
                  Keyword
                </TableCell>
                <TableCell style={{ width: 160 }}>
                  Possible word
                </TableCell>
                <TableCell style={{ width: 160 }}>
                  Keyword ID
                </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? possibleWords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : possibleWords
            ).map((row,i) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.keyword}
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                {row.keywordAudit == false ? 
                    <div>
                        <div className='pull-left'>{row.Possibleword}</div>
                        <div className='pull-left edit-possible-word cur-pointer' onClick={()=>{handleEdit(i,true)}}>
                            <EditIcon  /></div> 
                        </div>
                    : <div className="pos-rel"><TextField required id="filled-required" label="Possible word"
                    variant="filled"
                    value={possibleWords[i].Possibleword}
                    onChange={(e)=>{
                        handlePossibleWordChange(e,i);
                    }}
                    /> <ClearIcon className='closeIcon cur-pointer' onClick={()=>{handleEdit(i,false)}} /> </div>}
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                    <Button variant="contained" color="primary" onClick={()=>{
                        props.saveKeywordAudit({userId:cookie.load('username'),Possibleword:row.Possibleword,id:row.id})
                    }}>
                        Audit
                    </Button>
                </TableCell>
              </TableRow>
            ))}
  
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                colSpan={3}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    );
  }
class CreateKeyword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            keywordList:[],
            keyword:'',
            suggestions:[],
            user_id: '',
            pageNumber: 1,
            records: {},
            recordsError: {},
            transcriptText: '',
            model: false,
            notified:false
        }
        // this.rederAudioFiles = this.rederAudioFiles.bind(this)
        this.handleOnChange = this.handleOnChange.bind(this)

    }
    componentWillReceiveProps(nextProps) {
        // console.log(nextProps)
        // console.log(this.props)
        console.log("Receive props",nextProps)
        const { records, recordsError } = this.state
        
        if (!nextProps.CreatorDashboardReducer.loading) {
            records.keyword = '';
            records.suggestions = []
            recordsError.keyword = '';
            this.setState({records,recordsError})
        }
        // this.props.fetchEnglishKeywords()
    }

    componentWillMount() {
        this.props.setPageName('Keyword Audit')
        this.props.fetchKeywordsAudit(cookie.load('username'))
    }

    handleOnChange(e, key) {
        const { records, recordsError } = this.state
        records[key] = e.target.value;
        this.setState({ records, recordsError })
    }
    

    render() {
        
        const { CreatorDashboardReducer: { loading, keywordAudit,success } } = this.props
        const { filterValues, user_id,keyword,records,suggestions } = this.state
        
        return (
            <div className="audio-to-trans-page superqa_team" >
                {/* <PlayCircleFilledIcon />
                            <p style={{ paddingLeft: 10 }}>{item.file_path.replace(`http://10.101.1.134/rec/`, ``)}</p> */}
                {/* {this.state.model ? this.renderRejectReasonModel() : null} */}
                {console.log(keywordAudit)}
                {loading ? <Loader /> :
                    <div className="audio-result-contnet keyword-suggestions-container">
                        {<KeywordAuditTable rows={keywordAudit.data} saveKeywordAudit={this.props.saveKeywordAudit}/>}
                    </div>}



            </div>
        )
    }
}



function mapStateToProps(state) {
    const { userLogin, CreatorDashboardReducer } = state
    //const { QAManagement, loading, success, error } = state.AudioToTrackReducer

    return {
        CreatorDashboardReducer,
        //loading,
        userLogin,
        //success,
        //error
    }
}



export default withRouter(connect(
    mapStateToProps,
    {
        getAuditedListByUser,
        fetchQATranscriptionAudio,
        setPageName,
        superQAAudioDecision,
        fetchRejectReajonList,
        fetchEnglishKeywords,
        saveKeywordSuggestions,
        fetchKeywordsAudit,
        saveKeywordAudit
    }
)(CreateKeyword));

